import React from 'react';
import AccountManagementRouter from './AccountManagementRouter';

export default function AccountManagementPage() {
  return <AccountManagementRouter />;
}
